// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pageWrapper {
  min-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}

.supportFooter {
  margin-top: auto;
}

.containerFluxoPerguntas {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding-left: 45px;
  width: calc(100% - 45px);
}

.containerPerguntas {
  display: flex;
  width: 100%;
  min-height: 150px;
  max-height: 300px;
  padding: 0px 0px 0 45px;
  border-bottom: 1px solid #979ea4;
  background-color: #fff;
  flex-direction: column;
}

.upperPerguntas {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/FluxoPerguntas/fluxoPeguntas.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;EACvB,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb","sourcesContent":[".pageWrapper {\n  min-height: calc(100vh - 60px);\n  display: flex;\n  flex-direction: column;\n}\n\n.supportFooter {\n  margin-top: auto;\n}\n\n.containerFluxoPerguntas {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding-left: 45px;\n  width: calc(100% - 45px);\n}\n\n.containerPerguntas {\n  display: flex;\n  width: 100%;\n  min-height: 150px;\n  max-height: 300px;\n  padding: 0px 0px 0 45px;\n  border-bottom: 1px solid #979ea4;\n  background-color: #fff;\n  flex-direction: column;\n}\n\n.upperPerguntas {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
